import React, {ReactElement, Component, useContext, Dispatch, SetStateAction} from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'antd';
import {Link, withRouter} from "react-router-dom";
import {LeftOutlined, MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';

// 全局变量
import {ContentSidebarToggleContext} from '../contexts/content-sidebar-toggle';

const ArrowBack = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)>=>{

    const {history, backTo, sidebarToggle} =props,
        [content_sidebar_toggle, set_content_sidebar_toggle]: [boolean, Dispatch<SetStateAction<boolean>>] = useContext(ContentSidebarToggleContext);

    const history_back= ()=>{
        switch (backTo){
            case 'instance_list' : history.push('/instance-list');break;
            default: break;
        }
        set_content_sidebar_toggle(true);
    };

    return(
        <div className={'breadcrumb_header bg_transparent breadcrumb mb-10'}>
            {sidebarToggle&&<Link
                to={'#'}
                onClick={()=> set_content_sidebar_toggle(!content_sidebar_toggle)}
            >{
                content_sidebar_toggle ? 
                <span className="card_title"><MenuFoldOutlined /></span> : 
                <span className="card_title"><MenuUnfoldOutlined /></span>
            }</Link>}
            <Link to={'#'} onClick={history_back}>
                <Button>
                    <LeftOutlined />
                    &nbsp;
                    <span><FormattedMessage id={'back_to'}/>&nbsp;<FormattedMessage id={backTo}/></span>
                </Button>
            </Link>
        </div>
    )
};

export default withRouter(ArrowBack);
